import {deleteAction, getAction, postAction} from '../index'


// 数据源分页查询
export const dataSourcePage = (query) => getAction('/easydata/dataSource/page', query)
export const copyDataSource = (query) => getAction('/easydata/dataSource/copyDataSource', query)
export const addDsInfo = (param) => postAction('/easydata/dataSource/add', param)
export const delDs = (param) => deleteAction('/easydata/dataSource/delete', param)
export const exportOne = (param) => getAction('/easydata/dataSource/exportOne', param)
export const importDs = (param) => postAction('/easydata/dataSource/import', param)
//db
export const easyDbList = (query) => getAction('/easydata/dataSource/easyDb/list', query)
export const addEasyDb = (param) => postAction('/easydata/dataSource/easyDb/add', param)
export const addAllEasyDb = (param) => postAction('/easydata/dataSource/easyDb/addList', param)


// 数据源分页查询
export const addFieldModel = (param) => postAction('/easydata/fieldInfo/addModel', param)
export const getFieldListByDsId = (param) => getAction('/easydata/fieldInfo/list', param)

// 数据源分页查询
export const addTableInfo = (param) => postAction('/easydata/tableInfo/add', param)
export const getTableInfoByDsId = (param) => getAction('/easydata/tableInfo/one', param)
//db
export const getDbTableInfoByDsId = (param) => getAction('/easydata/dbTableInfo/one', param)


// 数据源分页查询
export const deleteAllViCol = (param) => postAction('/easydata/tableOperator/deleteAll', param)
export const reloadAllViCol = (param) => postAction('/easydata/tableOperator/reloadAll', param)
export const createTable = (param) => postAction('/easydata/tableOperator/create', param)
export const getTableSchema = (param) => postAction('/easydata/tableOperator/getTableSchema', param)
export const dropTable = (param) => postAction('/easydata/tableOperator/drop', param)
export const clearTable = (param) => postAction('/easydata/tableOperator/clear', param)
export const truncateTable = (param) => postAction('/easydata/tableOperator/truncate', param)
export const alterTable = (param) => postAction('/easydata/tableOperator/alter', param)
//db
export const createDbTable = (param) => postAction('/easydata/dbTableOperator/create', param)
export const truncateDbTable = (param) => postAction('/easydata/dbTableOperator/truncate', param)
export const alterDbTable = (param) => postAction('/easydata/dbTableOperator/alter', param)
export const clearDbTable = (param) => postAction('/easydata/dbTableOperator/clear', param)
export const deleteAllDbViCol = (param) => postAction('/easydata/dbTableOperator/deleteAll', param)
export const reloadAllDbViCol = (param) => postAction('/easydata/dbTableOperator/reloadAll', param)
export const dropDbTable = (param) => postAction('/easydata/dbTableOperator/drop', param)

// 数据源分页查询
export const addSqlIdInfo = (param) => postAction('/easydata/tableSql/addModel', param)
export const getSqlIdList = (param) => getAction('/easydata/tableSql/list', param)


/** 根据数据源名称查询视图列表 */
export const controlInfoViewList = (param) => getAction('/easydata/controlInfo/viewList', param);
/** 保存新增的视图 */
export const addViewModel = (param) => postAction( '/easydata/controlInfo/addViewModel', param)
/** 根据ID删除视图 */
export const deleteViewModel = (param) => deleteAction( '/easydata/controlInfo/deleteViewModel', param);
/** 根据视图ID及数据源复制视图 */
export const copyViewModel = (param) => postAction( '/easydata/controlInfo/copyViewModel', param)

/** 根据数据源名称及视图ID查询控件信息 */
export const listControlInfo = (param) => getAction( '/easydata/controlInfo/listByViewId', param);
/** 根据数据源名称查询虚拟列 */
export const listFieldInfo = (param) => getAction( '/easydata/fieldInfo/list', param);
/** 保存控件信息整个table */
export const saveControlModel = (param) => postAction( '/easydata/controlInfo/saveControlModel', param);
/** 删除一行控件信息 */
export const deleteControlInfo = (param) => deleteAction( '/easydata/controlInfo/deleteControlInfo', param);

/** 获取控件属性信息 */
export const getControlProps = (controlId) => getAction( '/easydata/controlProps/one', {controlId});
/** 新增控件属性 */
export const addControlProps = (param) => postAction( '/easydata/controlProps/add', param);


// 批量导出
export default {
  dataSourcePage,
  copyDataSource,
  addDsInfo,
  delDs,
  exportOne,
  importDs,
  easyDbList,
  addEasyDb,
  addAllEasyDb,

  addFieldModel,
  getFieldListByDsId,

  addTableInfo,
  getTableInfoByDsId,
  getDbTableInfoByDsId,

  deleteAllViCol,
  reloadAllViCol,
  createTable,
  getTableSchema,
  dropTable,
  clearTable,
  truncateTable,
  alterTable,
  createDbTable,
  truncateDbTable,
  alterDbTable,
  clearDbTable,
  deleteAllDbViCol,
  reloadAllDbViCol,
  dropDbTable,


  addSqlIdInfo,
  getSqlIdList,

  controlInfoViewList,
  addViewModel,
  deleteViewModel,
  copyViewModel,
  listControlInfo,
  listFieldInfo,
  saveControlModel,
  deleteControlInfo,
  getControlProps,
  addControlProps
}
